import { render } from "./Dashboard.vue?vue&type=template&id=26924546"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=26924546&lang=css"

import exportComponent from "/Users/alexis/Desktop/Software/grupo_albarran_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__